module.exports = __webpack_public_path__ + "img/博物館行動導遊.c09ddd5d.jpg";